import React from 'react';
import { connect } from 'react-redux';
import Selector from '../util/Selector';

// AggregationMethods in conversion.py
const AGGS = [
  { name: 'mean', display: 'Mean (average) of the values', allowed: 'Continuous' },
  { name: 'sum', display: 'Sum of the values', allowed: 'Continuous' },
  { name: 'min', display: 'Smallest value' },
  { name: 'max', display: 'Largest value' },
];

const AggregationSelector = ({ selected, onChange, measurementId, measurements }) => {
  const dataType = measurements[measurementId]?.units[0].data_type;
  return (
    <Selector
      options={AGGS.filter(({ allowed }) => allowed == null || allowed === dataType).map(
        ({ name, display }) => ({
          id: name,
          key: name,
          display: `${name} - ${display}`,
        })
      )}
      selected={selected ? `${selected}` : ''}
      onChange={({ target: { value } }) => onChange(value)}
    />
  );
};

export default connect(
  ({
    entities: {
      measurements: { byId },
    },
  }) => ({ measurements: byId })
)(AggregationSelector);
